module.exports = __webpack_public_path__ + "static/media/Wave_Desktop.e28dc0d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Wave_Desktop.png
// module id = 368
// module chunks = 0